export function sectionProgress(top: number, height: number, stageHeight: number, inset = 80) {
  return Math.max(0, Math.min(1, (inset - top) / Math.max(1, height - stageHeight)));
}

// Normalized image centers and widths at the beginning and end of the opening.
export const OPENING_TITLE_END = 0.18;
export const OPENING_TRAVEL_START = 0.22;
export function smoothOpeningProgress(current: number, target: number, delta: number) {
  const next = current + (target - current) * (1 - Math.exp(-20 * Math.min(delta, 0.05)));
  return Math.abs(target - next) < 0.00001 ? target : next;
}

const openingFrames = [
  [0.82, 0.55, 0.26, -0.22, 0.35, 0.24],
  [0.15, 0.82, 0.15, 0.44, 0.52, 0.32],
  [1.28, 0.46, 0.25, 0.86, 0.62, 0.22],
  [1.7, 0.75, 0.17, 0.12, 0.86, 0.16],
  [1.85, 0.2, 0.13, 1.07, 0.15, 0.15],
];

export function openingFrame(index: number, progress: number, width: number, height: number, ratio: number) {
  const f = openingFrames[index % openingFrames.length];
  const travel = Math.max(0, Math.min(1, (progress - OPENING_TRAVEL_START) / (1 - OPENING_TRAVEL_START)));
  const mix = (a: number, b: number) => a + (b - a) * travel;
  const mobile = width < 700;
  const imageWidth = Math.min(
    mix(f[2], f[5]) * width * (mobile ? 1.65 : 1),
    height * ratio * mix(index === 1 ? 0.32 : 0.66, 0.76),
  );
  return {
    x: mix(mobile && index === 0 ? 0.72 : f[0], f[3]) * width,
    y: mix(height < 450 && index === 1 ? 1.3 : f[1], f[4]) * height + (mobile ? height * 0.06 : 0),
    width: imageWidth,
    height: imageWidth / ratio,
  };
}

export function panoramaFrame(index: number, progress: number, count: number) {
  const offset = index - progress * Math.max(0, count - 1);
  const wrapped = ((offset + count / 2) % count + count) % count - count / 2;
  const angle = wrapped * 0.38;
  return { x: Math.sin(angle) * 7, z: (Math.cos(angle) - 1) * 7, rotation: angle, visible: Math.abs(angle) < 1.55 };
}
